export const SizeExperiment = Object.freeze({
  'RegularSize': 'regular_size',
  'ShortSize': 'short_size',
})
